import { useState, useParams, FaPhoneAlt, DataTable, noDatapng, ToastContainer, MdErrorOutline, FaArrowAltCircleRight, overlayStyle, loaderStyle } from '../../common/common';
import { useErrorContext } from '../../context/ErrorContext';
import MidViewSuppliers from '../../middleware/Supplier/MidViewSuppliers';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';

const ViewSuppliers = () => {
  const { type } = useParams();
  const [issidebarOpen, setIssidebarOpen] = useState(true);
  const { error } = useErrorContext();
  const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
  const { users, isLoading, selectsupplier, handleCall, products } = MidViewSuppliers(type);
  if (Array.isArray(users) && users.length > 0) {
    var AppID = users[0]['AppID'];
    var ProfilePic = users[0]['ProfilePic'];
    var usertype = users[0]['UserType'];
    var username = users[0]['FullName'];
    var CompanyName = users[0]['CompanyName'];
    var userAddress1 = users[0]['Address1'];
    var userAddress2 = users[0]['Address2'];
    var Mobile = users[0]['Mobile'];
    var RegistrationDate = users[0]['RegistrationDate'];
    var EmailAddress = users[0]['EmailAddress'];

  }

  const columns = [
    //   {
    //     name:"Avtars",
    //     width: "80px" ,
    //     style: {
    //       color: 'black ',
    //       fontSize: '14px',
    //       fontWeight: '500',
    //     },
    //     selector:(row) =><Stack direction="row" >

    //     <Avatar sx={{ width: 35, height: 35 }} style={{backgroundColor: randomColor()} }>{row.full_name.substring(0, 1)}</Avatar>
    // </Stack>,
    // },  
    {
      name: "Action",
      selector: (row) =>
        <div className='flex flex-row '>
          {row.status === 1 ? (
            <button className='btn btn-primary btn-sm' onClick={() => selectsupplier(row.unique_key)}>View product</button>
          ) : (
            <button className='btn btn-danger btn-sm' >In Active</button>
          )}
        </div>,
    },
    {
      name: "Phone Number",
      style: {
        color: 'black ',
        fontSize: '14px',
        fontWeight: '500',
      },
      sortable: true,
      selector: (row) => <div className="flex flex-row">
        <FaPhoneAlt className="text-white bg-[#086c00] h-6 w-6 p-1 rounded-full" style={{ cursor: 'pointer' }} onClick={() => handleCall(row.mobile)} />
        <span className="ml-2">{row.mobile}</span>
      </div>,
    },
    {
      name: "Full Name",
      style: {
        color: 'black ',
        fontSize: '14px',
        fontWeight: '500',
      },
      sortable: true,
      selector: (row) => row.full_name,
    },
    {
      name: "Company Name",
      style: {
        color: 'black ',
        fontSize: '14px',
        fontWeight: '500',
      },
      sortable: true,
      selector: (row) => row.company_name,
    },
    {
      name: "Company Address",
      style: {
        color: 'black ',
        fontSize: '14px',
        fontWeight: '500',

      },
      sortable: true,
      selector: (row) => row.address1 + row.address2,
    },
    {
      name: "City",
      style: {
        color: 'black ',
        fontSize: '14px',
        fontWeight: '500',
      },
      sortable: true,
      selector: (row) => row.city_name,
    },
    {
      name: "State",
      style: {
        color: 'black ',
        fontSize: '14px',
        fontWeight: '500',
      },
      sortable: true,
      selector: (row) => row.state_name,
    },
    {
      name: "Country",
      style: {
        color: 'black ',
        fontSize: '14px',
        fontWeight: '500',
      },
      sortable: true,
      selector: (row) => row.country_name,
    },
    // {
    //     name:"Action",
    //     selector:(row) =><div className='flex flex-row '><Tippy content={<span>View Sub Category</span>}><button className='btn btn-warning  p-3 rounded-full mx-1 ' ><FaEye /></button></Tippy></div> ,
    // },

  ]

  return (
    <div className="md:flex md:flex-row md:w-full">
      <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
        <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} />
      </div>
      <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
        <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
        <div className="grid grid-cols-12">
          <div className="col-start-1 col-end-13 p-2">
            <div className=" text-xl text-[#1e3a8a]  ">
              <h1 className=' text-lg text-theme-color-text font-bold'> Suppliers</h1>
              <p className=' text-gray-600 text-[16px] '>Manage and organize your product vendors with key details for smooth procurement and sourcing</p>
            </div>
            <div className="border-2 px-3 py-4 flex-row rounded-xl bg-white shadow-xs">
              <div className=' relative flex flex-col min-w-0 break-words'>
                <div className='p-3'>
                  <div className='flex flex-row justify-between items-center mb-4'>
                    <h5 className=" capitalize text-xl font-bold mb-0">View Suppliers</h5>
                  </div>

                  {(products && Array.isArray(products) && products.length > 0) ?
                    // <Datatable columns={columns} data={categories} selectableRows pagination noDataComponent='No Data Available in Table ' />  
                    <DataTable
                      columns={columns}
                      data={products}
                      pagination
                      responsive
                      highlightOnHover

                    />
                    : <center><img src={noDatapng} height={300} width={300} /> <h1 className='text-lg -translate-y-10 text-gray-300 font-bold'> Opps ! No Data Found </h1></center>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  )
}

export default ViewSuppliers